import { Validator } from 'vee-validate'
import AcceptBackDate from './acceptBackDate'
import AcceptStartDate from './acceptStartDate'
import AcceptToDate from './acceptToDate'
import AcceptTodayDate from './acceptTodayDate'
import OptCvr from './optCvr'

export default function install() {
  Validator.extend('accept_back_date', AcceptBackDate)
  Validator.extend('accept_start_date', AcceptStartDate)
  Validator.extend('accept_to_date', AcceptToDate)
  Validator.extend('accept_today_date', AcceptTodayDate)
  Validator.extend('pkg_opt_cvr', OptCvr)
}
